import _ from 'lodash';
export function  getApprovalHeaderInfo(workFlowId,responseObj) {
    let headerInfo = {};

    headerInfo = {
        "team":{
            "key":!_.isUndefined(workFlowId+"approvalDetails.headerInfo.teamLabel")? workFlowId+'.approvalDetails.headerInfo.teamLabel' : "",
            "value":_.has(responseObj,'dataToDisplay.approvalDetails.headerInfo.headerValue') ? responseObj.dataToDisplay.approvalDetails.headerInfo.headerValue : ""
        },
        "initiatedBy":{
            "key":!_.isUndefined(workFlowId+".approvalDetails.headerInfo.initiatedByLabel") ? workFlowId+".approvalDetails.headerInfo.initiatedByLabel" : "",
            "value":""
        },
        "createdOn":{
            "key":!_.isUndefined(workFlowId+".approvalDetails.headerInfo.createdOnLabel") ? workFlowId+".approvalDetails.headerInfo.createdOnLabel" : "",
            "value":_.has(responseObj,'createdAt') ? responseObj.createdAt : ""
        },
        "approvalId":{
            "key":!_.isUndefined(workFlowId+".approvalDetails.headerInfo.approvalId") ? workFlowId+".approvalDetails.headerInfo.approvalId" : "",
            "value":_.has(responseObj,'approvalId') ? responseObj.approvalId : ""
        }
    };

    return headerInfo;
}